var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3548 1.82725C10.3548 1.82725 11.3261 1.4485 11.2452 2.36832C11.2182 2.74708 10.9754 4.0727 10.7865 5.50655L10.139 9.75398C10.139 9.75398 10.085 10.3762 9.59935 10.4844C9.11368 10.5926 8.3852 10.1057 8.25027 9.99745C8.14235 9.9163 6.2267 8.69888 5.55215 8.1037C5.36327 7.94138 5.14742 7.61673 5.57912 7.23798L8.41218 4.53263C8.73595 4.20798 9.05972 3.45047 7.71065 4.3703L3.93328 6.9404C3.93328 6.9404 3.50158 7.21093 2.69215 6.96745L0.938355 6.42638C0.938355 6.42638 0.290803 6.02058 1.39704 5.61475C4.09518 4.34323 7.41388 3.04465 10.3548 1.82725Z",
    fill: "rgba(0, 0, 0, 0.54)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.3461688a15283d8ca1b7cce5ea06e190.svg";
export { ForwardRef as ReactComponent };